module.exports = __webpack_public_path__ + "static/media/tc.6cb2c745.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tc.svg
// module id = 2220
// module chunks = 0